import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LoginPage } from "../pages/auth/LoginPage.component";
import { SubscriptionPage } from "../pages/subscription/SubscriptionPage.component";
import { PaymentPage } from "../pages/payment/PaymentPage.component";
import { PlanPage } from "../pages/plan/PlanPage.component";
import { AccountPage } from "../pages/account/AccountPage.component";
import { TimeOutPage } from "../pages/timeOut/TimeOutPage.component";
import { PrivateRoutes } from "./PrivateRoutes";
import { Layout } from "../components/layout/layout/Layout.component";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route
            element={
              <Layout>
                <AccountPage />
              </Layout>
            }
            path="/"
            exact
          />
          <Route
            element={
              <Layout>
                <SubscriptionPage />
              </Layout>
            }
            path="/subscription"
            exact
          />
          <Route
            element={
              <Layout>
                <PlanPage />
              </Layout>
            }
            path="/plans"
          />
          <Route
            element={
              <Layout>
                <PaymentPage />
              </Layout>
            }
            path="/payment"
          />
          <Route
            element={
              <Layout>
                <AccountPage />
              </Layout>
            }
            path="/account"
          />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sessionTimeOut" element={<TimeOutPage />} />
      </Routes>
    </BrowserRouter>
  );
};

// <Route path="*" element={<h1>Not found page</h1>} />
